// React Query Keys
export const QUESTIONS_KEY = 'questions'
export const QUESTIONS_TOTAL_KEY = 'questions/all'

// API Constants
export const REASON = 'REASON'
export const OPTION = 'OPTION'
